<script>

import { Vue3Lottie } from 'vue3-lottie'
import LoadingJson from '../../assets/Json/LoadingPic.json'

export default {
  name:'LoadingPic',
  components: {
    Vue3Lottie,
  },

  setup(){

    return{

      LoadingJson

    }
  }
}

</script>

<template>

  <Vue3Lottie class="loading_pic" :animationData="LoadingJson" :height="100" :width="100" />

</template>

<style scoped>


</style>